// extracted by mini-css-extract-plugin
module.exports = {"selectContent":"SelectCurrentQuestion_selectContent__WA0fZ","list":"SelectCurrentQuestion_list__3dJQx","listItem":"SelectCurrentQuestion_listItem__11Ry0"};